"use strict";
/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HmoRecord$ = exports.HmoRecord$outboundSchema = exports.HmoRecord$inboundSchema = void 0;
exports.hmoRecordToJSON = hmoRecordToJSON;
exports.hmoRecordFromJSON = hmoRecordFromJSON;
const z = __importStar(require("zod"));
const primitives_js_1 = require("../../../lib/primitives.js");
const schemas_js_1 = require("../../../lib/schemas.js");
const rfcdate_js_1 = require("../../types/rfcdate.js");
const hmorecordappeal_js_1 = require("./hmorecordappeal.js");
const hmorecordhmomanager_js_1 = require("./hmorecordhmomanager.js");
const hmorecordlicenceholder_js_1 = require("./hmorecordlicenceholder.js");
/** @internal */
exports.HmoRecord$inboundSchema = z.object({
    appeal: z.nullable(hmorecordappeal_js_1.HmoRecordAppeal$inboundSchema),
    conditions: z.nullable(z.string()),
    council_name: z.nullable(z.string()),
    hmo_address: z.nullable(z.string()),
    hmo_manager: z.nullable(hmorecordhmomanager_js_1.HmoRecordHmoManager$inboundSchema),
    item_id: z.nullable(z.string()),
    licence_expiry: z.nullable(z.string().transform(v => new rfcdate_js_1.RFCDate(v))),
    licence_holder: z.nullable(hmorecordlicenceholder_js_1.HmoRecordLicenceHolder$inboundSchema),
    licence_start: z.nullable(z.string().transform(v => new rfcdate_js_1.RFCDate(v))),
    licence_type: z.nullable(z.string()),
    max_occupancy: z.nullable(z.number().int()),
    number_of_households: z.nullable(z.number().int()),
    number_of_rooms_providing_living_accommodation: z.nullable(z.number().int()),
    number_of_rooms_providing_sleeping_accommodation: z.nullable(z.number().int()),
    number_of_shared_bathrooms: z.nullable(z.number().int()),
    number_of_shared_kitchens: z.nullable(z.number().int()),
    number_of_shared_non_self_contained_units: z.nullable(z.number().int()),
    number_of_shared_self_contained_units: z.nullable(z.number().int()),
    number_of_shared_toilets: z.nullable(z.number().int()),
    number_of_storeys: z.nullable(z.number().int()),
    property_description: z.nullable(z.string()),
    property_type: z.nullable(z.string()),
    updated_at: z.nullable(z.string().transform(v => new rfcdate_js_1.RFCDate(v))),
    uprn: z.string(),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        "council_name": "councilName",
        "hmo_address": "hmoAddress",
        "hmo_manager": "hmoManager",
        "item_id": "itemId",
        "licence_expiry": "licenceExpiry",
        "licence_holder": "licenceHolder",
        "licence_start": "licenceStart",
        "licence_type": "licenceType",
        "max_occupancy": "maxOccupancy",
        "number_of_households": "numberOfHouseholds",
        "number_of_rooms_providing_living_accommodation": "numberOfRoomsProvidingLivingAccommodation",
        "number_of_rooms_providing_sleeping_accommodation": "numberOfRoomsProvidingSleepingAccommodation",
        "number_of_shared_bathrooms": "numberOfSharedBathrooms",
        "number_of_shared_kitchens": "numberOfSharedKitchens",
        "number_of_shared_non_self_contained_units": "numberOfSharedNonSelfContainedUnits",
        "number_of_shared_self_contained_units": "numberOfSharedSelfContainedUnits",
        "number_of_shared_toilets": "numberOfSharedToilets",
        "number_of_storeys": "numberOfStoreys",
        "property_description": "propertyDescription",
        "property_type": "propertyType",
        "updated_at": "updatedAt",
    });
});
/** @internal */
exports.HmoRecord$outboundSchema = z.object({
    appeal: z.nullable(hmorecordappeal_js_1.HmoRecordAppeal$outboundSchema),
    conditions: z.nullable(z.string()),
    councilName: z.nullable(z.string()),
    hmoAddress: z.nullable(z.string()),
    hmoManager: z.nullable(hmorecordhmomanager_js_1.HmoRecordHmoManager$outboundSchema),
    itemId: z.nullable(z.string()),
    licenceExpiry: z.nullable(z.instanceof(rfcdate_js_1.RFCDate).transform(v => v.toString())),
    licenceHolder: z.nullable(hmorecordlicenceholder_js_1.HmoRecordLicenceHolder$outboundSchema),
    licenceStart: z.nullable(z.instanceof(rfcdate_js_1.RFCDate).transform(v => v.toString())),
    licenceType: z.nullable(z.string()),
    maxOccupancy: z.nullable(z.number().int()),
    numberOfHouseholds: z.nullable(z.number().int()),
    numberOfRoomsProvidingLivingAccommodation: z.nullable(z.number().int()),
    numberOfRoomsProvidingSleepingAccommodation: z.nullable(z.number().int()),
    numberOfSharedBathrooms: z.nullable(z.number().int()),
    numberOfSharedKitchens: z.nullable(z.number().int()),
    numberOfSharedNonSelfContainedUnits: z.nullable(z.number().int()),
    numberOfSharedSelfContainedUnits: z.nullable(z.number().int()),
    numberOfSharedToilets: z.nullable(z.number().int()),
    numberOfStoreys: z.nullable(z.number().int()),
    propertyDescription: z.nullable(z.string()),
    propertyType: z.nullable(z.string()),
    updatedAt: z.nullable(z.instanceof(rfcdate_js_1.RFCDate).transform(v => v.toString())),
    uprn: z.string(),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        councilName: "council_name",
        hmoAddress: "hmo_address",
        hmoManager: "hmo_manager",
        itemId: "item_id",
        licenceExpiry: "licence_expiry",
        licenceHolder: "licence_holder",
        licenceStart: "licence_start",
        licenceType: "licence_type",
        maxOccupancy: "max_occupancy",
        numberOfHouseholds: "number_of_households",
        numberOfRoomsProvidingLivingAccommodation: "number_of_rooms_providing_living_accommodation",
        numberOfRoomsProvidingSleepingAccommodation: "number_of_rooms_providing_sleeping_accommodation",
        numberOfSharedBathrooms: "number_of_shared_bathrooms",
        numberOfSharedKitchens: "number_of_shared_kitchens",
        numberOfSharedNonSelfContainedUnits: "number_of_shared_non_self_contained_units",
        numberOfSharedSelfContainedUnits: "number_of_shared_self_contained_units",
        numberOfSharedToilets: "number_of_shared_toilets",
        numberOfStoreys: "number_of_storeys",
        propertyDescription: "property_description",
        propertyType: "property_type",
        updatedAt: "updated_at",
    });
});
/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
var HmoRecord$;
(function (HmoRecord$) {
    /** @deprecated use `HmoRecord$inboundSchema` instead. */
    HmoRecord$.inboundSchema = exports.HmoRecord$inboundSchema;
    /** @deprecated use `HmoRecord$outboundSchema` instead. */
    HmoRecord$.outboundSchema = exports.HmoRecord$outboundSchema;
})(HmoRecord$ || (exports.HmoRecord$ = HmoRecord$ = {}));
function hmoRecordToJSON(hmoRecord) {
    return JSON.stringify(exports.HmoRecord$outboundSchema.parse(hmoRecord));
}
function hmoRecordFromJSON(jsonString) {
    return (0, schemas_js_1.safeParse)(jsonString, (x) => exports.HmoRecord$inboundSchema.parse(JSON.parse(x)), `Failed to parse 'HmoRecord' from JSON`);
}
//# sourceMappingURL=hmorecord.js.map